import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createTransaction, updateTransaction, statusChange, statusSuspend } from "../api/Api.js";

const usePaymentRequest = () => {
  const queryClient = useQueryClient();

  const createPayment = useMutation({
    mutationFn: (data) => createTransaction(data),
    onMutate: async () => {
      toast.loading("Creating payment...", {
        id: 'update-toast',
        position: "top-right",
      });
    }, 
    onSuccess: (response) => {
      // Invalidate and refresh queries to ensure data consistency
      queryClient.invalidateQueries(["transactions", 1]);

      // Update cached data
      queryClient.setQueryData(["transactions", 1], (oldData) => {
        if (!oldData) return;
        return {
          ...oldData,
          data: [response.data, ...oldData.data].slice(0, 10),
        };
      });
      toast.dismiss('update-toast');
      // Show success notification
      toast.success("Transaction created successfully", {
        duration: 3000,
        position: "top-right",
      });
    },
    onError: (error) => {
      // Display error notification
      toast.dismiss('update-toast');
      toast.error(error.response?.data?.message || "Failed to create payment", {
        duration: 4000,
        position: "top-right",
      });
      console.error(error);
    },
  });

  const updatePayment = useMutation({
    mutationFn: ({ id, data }) => updateTransaction(id, data),
    onMutate: async () => {
      toast.loading("Updating payment...", {
        id: 'update-toast',
        position: "top-right",
      });
    },
    onSuccess: (response, variables) => {
      // Get the current page from queryClient
      const currentPage =
        queryClient.getQueryData(["transactions"])?.currentPage || 1;

      queryClient.invalidateQueries(["transactions", currentPage]);

      // Update the specific transaction in the cache
      queryClient.setQueryData(["transactions", currentPage], (oldData) => {
        if (!oldData) return;
        return {
          ...oldData,
          data: oldData.data.map((item) =>
            item._id === variables.id ? response.data : item
          ),
        };
      });
      toast.dismiss('update-toast');
      toast.success("Transaction updated successfully", {
        position: "top-right",
      });
    },
    onError: (error) => {
      // Display error notification
      toast.dismiss('update-toast');
      toast.error(
        error.response?.data?.message || "Transaction update failed",
        {
          duration: 4000,
          position: "top-right",
        }
      );
      console.error(error);
    },
  });


  const updateStatus = useMutation({
    mutationFn: (formData) => statusChange(formData),
    onMutate: async () => {
      toast.loading("Updating Status..", {
        id: 'update-toast',
        position: "top-right",
        // duration until onsuccess or onerror  
        // duration : 

      })
    },
    onSuccess: async (response, variables) => {
      // console.log(`response in mutation fun ${response}`);
      const currentPage = queryClient.getQueryData(["transactions"])?.currentPage || 1;
      const filters = queryClient.getQueryData(["transactions"])?.filters || {};
      queryClient.invalidateQueries(["transactions", currentPage, filters]);
      //setting or updating data
      queryClient.setQueryData(["transactions", currentPage, filters], (oldData) => {
        if (!oldData) return;
        return {
          ...oldData,
          data: oldData.data?.map((item) =>
            item.tran_id === variables.trans_id ? item.status = response.data.newStatus : item
          ),
        };
      });
      toast.dismiss('update-toast');

      toast.success(`${response.data.message} succesfully` || "status updated successfully", {
        position: "top-right",
      });
    },

    onError: async (error) => {
      toast.dismiss('update-toast');
      toast.error(
        error.response?.data.message || "updating status failed!",
        {
          duration: 3000,
          position: "top-right"
        }
      )
      console.log(error);
    }
  })

  const updateSuspend = useMutation({
    mutationFn: ({id, name}) => statusSuspend(id, name),
    onMutate: async () => {
      toast.loading("updating status..", {
        position: "top-right",
        id: 'update-toast',
      }
      )
    },
    onSuccess: async (response, variables) => {
      // console.log(`response in mutation fun ,${response}`);
      const currentPage = queryClient.getQueryData(["transactions"])?.currentPage || 1;
      const filters = queryClient.getQueryData(["transactions"])?.filters || {};
      queryClient.invalidateQueries(["transactions", currentPage, filters]);
      queryClient.setQueryData(["transactions", currentPage, filters], (oldData) => {
        if (!oldData) return;
        return {
          ...oldData,
          data: oldData.data?.map((item) =>
            item.tran_id === variables.id ? item.status = response.data.newStatus : item
          ),
        };

      })
      toast.dismiss('update-toast');
      toast.success(`${response.data.message} successfully` || 'status suspended succesfully', {
        position: "top-right"
      });
    },
    onError: async (error) => {
      toast.dismiss('update-toast');
      toast.error(
        error.response?.data.message || "updating status failed!",
        {
          duration: 3000,
          position: "top-right"
        }
      )
      console.log(error);
    }
  })

  return {
    createPayment,
    updatePayment,
    isLoading: createPayment.isLoading || updatePayment.isLoading,
    iserror: createPayment.error || updatePayment.error,
    updateStatus,
    updateSuspend

  };
};

export default usePaymentRequest;
